import React, { Component } from "react";
import { Menu, Icon } from "antd";
import { withRouter } from "react-router-dom";
import ItemMenu from "./ItemMenu";

class DrawerMenu extends Component {
  render() {
    const { profile, signOut, location } = this.props;
    const { name } = profile.attributes;
    // console.log(location.pathname);
    return (
      <Menu
        style={{
          padding: "1rem 0",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          backgroundColor: "var(--color-primary-blue-dark)"
        }}
        selectedKeys={[location.pathname]}
        onSelect={() => this.props.selectedDrawerItem()}
      >
        <Menu.Item key="/">
          <ItemMenu
            icon="home"
            pathname="/"
            isDrawer={true}
            content={<span style={{ fontWeight: "bold" }}>Inicio</span>}
          />
        </Menu.Item>
        <Menu.Item key="/profile">
          <ItemMenu
            icon="user"
            pathname="/profile"
            isDrawer={true}
            content={<span style={{ fontWeight: "bold" }}>{name}</span>}
          />
        </Menu.Item>
        <Menu.Item key="/orders">
          <ItemMenu
            icon="solution"
            pathname="/orders"
            isDrawer={true}
            content={
              <span style={{ fontWeight: "bold" }}>Historial de Pedidos</span>
            }
          />
        </Menu.Item>
        <Menu.Item>
          <a
            style={{ display: "flex", alignItems: "center" }}
            onClick={signOut}
          >
            <Icon
              type="logout"
              style={{ fontSize: "2.5rem", color: "white" }}
            />
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                padding: "0 2rem",
                fontWeight: "bold",
                color: "white"
              }}
            >
              Salir
            </div>
          </a>
        </Menu.Item>
      </Menu>
    );
  }
}

export default withRouter(DrawerMenu);



// WEBPACK FOOTER //
// ./src/Components/Navigation/DrawerMenu.js